import * as React from 'react';
import { FontAwesomeIcon } from '../../components/ui/FontAwesomeIcon';

export const getActionStatusIcon = (status: string) => {
  if (status === 'New') {//Will be updated from Unresolved to New
    return (<FontAwesomeIcon icon="bell" color="orange" fixedWidth />)
  }
  if (status === 'Added') { //deprecated
    return null
    //return (<FontAwesomeIcon icon="bell" color={'blue-d10'} fixedWidth />)
  }
  if (status === 'Pending') {
    return (<FontAwesomeIcon icon="bell" color="blue" fixedWidth />)
  }
  if (status === 'Resolved') {
    return (<FontAwesomeIcon icon="thumbs-up" color="green" fixedWidth />)
  }
  if (status === 'No Action Needed') {
    return (<FontAwesomeIcon icon="minus-circle" color="lightgreen" fixedWidth />)
  }

  return (<FontAwesomeIcon icon="bell" muted fixedWidth />)
}
